import { STATUSES } from './siteMeta';

export const getSiteDisabled = (status: string | undefined | null) => {
  if (!status) return true;
  return STATUSES.SUSPENDED.includes(status?.toLowerCase());
};
